import axios from 'axios';
import { BASE_URL } from '@/global/util/constants';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getItem({ state, commit }, key) {
    const res = await axios.get(`${BASE_URL}/interface/etcd/item/${key}`);
    return res.data;
  },
  async getItemWithParams ({ state, commit }, { key, params }) {
    const res = await axios.get(`${BASE_URL}/interface/etcd/item/${key}`, {
      params
    })
    return res.data
  },
  async getJsonItem({ state, commit }, key) {
    const res = await axios.get(`${BASE_URL}/interface/etcd/jsonitem/${key}`);
    return res.data;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
